export enum FundType {
  TraditionalFund = 0,
  PrivateEquityFund = 1,
}
